var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[(_vm.flagType === 'no-order')?[_c('div',{staticClass:"empty-img no-order"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("C.NoData")))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }